import { UserAdminFilters, UsersAdmin } from '../models'

export const getUserAdminNameOrdered = (a: UsersAdmin, b: UsersAdmin): number => {
  return getUserAdminName(a).length - getUserAdminName(b).length
}

export const getUserAdminName = (user: UsersAdmin): string => {
  return {
    individual: `${user.first_name} ${user.last_name}`,
    business: `${user.userCompanyName}`
  }[user.user_type] || '-'
}

export const getFilteredUsers = (filters: UserAdminFilters, users: UsersAdmin[]): UsersAdmin[] => {
  let newUsers: UsersAdmin[] = users

  // Filter By Text
  if (filters.text) { // Filter By Text
    const text = filters.text?.toLowerCase()
    newUsers = newUsers.filter((user: UsersAdmin)=> {
      return (
        getUserAdminName(user).toLowerCase().includes(text) ||
        user.email.toLowerCase().includes(text) ||
        user.user_type.toLowerCase().includes(text) ||
        user.groups_name.some(g => g?.toLowerCase()?.includes(text))
      )
    })
  }

  // Filter by Status
  if (filters.status !== 'ALL') {
    const status = filters.status
    if (status === 'validated') { newUsers = newUsers.filter(u => u.is_validate && !u.is_rejected ) }
    else if (status === 'no_validated') { newUsers = newUsers.filter(u => !u.is_validate && !u.is_rejected) }
    else if (status === 'rejected') { newUsers = newUsers.filter(u => u.is_rejected ) }
  }

  // Filter by User Type
  if (filters.user_type !== 'ALL') {
    const userType = filters.user_type
    if (userType === 'business') { newUsers = newUsers.filter(u => u.user_type === 'business' ) }
    if (userType === 'individual') { newUsers = newUsers.filter(u => u.user_type === 'individual' ) }
  }

  // Filter By Groups
  if (filters.group !== 'ALL') {
    const group = filters.group
    newUsers = newUsers.filter(u => u.groups_name.some(g => g?.includes(group)))
  }
  return newUsers
}
